(function() { window.GUID_bb98af5b_6306_40e8_b887_a421086a567d = { getGuid: function() { return "bb98af5b-6306-40e8-b887-a421086a567d"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let NotificationTemplateGroupValue;
        (function (NotificationTemplateGroupValue) {
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["Undefined"] = 0] = "Undefined";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["GenericMessage"] = 1] = "GenericMessage";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["Tournament"] = 2] = "Tournament";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["League"] = 3] = "League";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["ScoreKeeper"] = 4] = "ScoreKeeper";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["Manager"] = 5] = "Manager";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["CompuSport"] = 6] = "CompuSport";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["CantDisable"] = 7] = "CantDisable";
        })(NotificationTemplateGroupValue = Enumeration.NotificationTemplateGroupValue || (Enumeration.NotificationTemplateGroupValue = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=NotificationTemplateGroupValue.pre.js.map
